﻿ObservableArray = (function () {
	function ObservableArray(collection) {
		// calling with `new` is optional
		if (!(this instanceof ObservableArray)) {
			return new ObservableArray(collection);
		}

		// add items from passed `collection` to `this`
		collection = collection || [];
		for (var i = 0; i < collection.length; i++) {
			this[i] = collection[i];
		}

		// set length so it acts like an array: http://stackoverflow.com/a/6599447/552067
		this.length = collection.length;

		// keep list of observing functions
		this.subscribers = {};

		// index-level watchers: { index: [fn, fn, ...] }
		this._indexWatchers = {};

		// key-based watchers: { keyField: { keyValue: [fn, fn, ...] } }
		this._keyWatchers = {};
	}

	ObservableArray.prototype = {
		// Subscribe a function to each event in a space-separated
		// list of events. If an event doesn't exist, create it.
		on: function (eventsStr, fn, callNow) {
			eventsStr.split(' ').forEach(function (event) {
				if (!this.subscribers[event]) this.subscribers[event] = [];
				this.subscribers[event].push(fn);
			}, this);
			if (callNow) fn.call(this);
			return this;
		},

		// Pass a space-separated list of events and a function to unsubscribe a specific
		// function from those events, pass just the events to unsubscribe all functions
		// from those events, or don't pass any arguments to cancel all subscriptions.
		off: function (eventsStr, fn) {
			if (eventsStr) {
				eventsStr.split(' ').forEach(function (event) {
					if (fn) {
						var fnIndex = this.subscribers[event].indexOf(fn);
						if (fnIndex >= 0) this.subscribers[event].splice(fnIndex, 1);
					} else {
						this.subscribers[event] = [];
					}
				}, this);
			} else {
				for (var event in this.subscribers) {
					this.subscribers[event] = [];
				}
			}
			return this;
		},

		// Notify all the subscribers of an event
		trigger: function (event) {
			var args = arguments;
			var t = this;
			function caller(fn) {
				fn.apply(t, args);
			}
			(this.subscribers[event] || []).forEach(caller);
			if (event !== 'any') (this.subscribers.any || []).forEach(caller);
			return this;
		},

		// Set value at specific index with change notification
		setAt: function (index, value) {
			var oldValue = this[index];
			this[index] = value;
			if (index >= this.length) this.length = index + 1;

			// notify index watchers
			this._notifyIndexWatchers(index, value, oldValue);

			// notify key watchers
			this._notifyKeyWatchersForIndex(index, value, oldValue);

			// trigger general 'change' event
			this.trigger('change', index, value, oldValue);
		},

		// Subscribe to changes at a specific index
		onIndex: function (index, fn) {
			if (!this._indexWatchers[index]) this._indexWatchers[index] = [];
			this._indexWatchers[index].push(fn);
			return this;
		},

		// Unsubscribe from index-level changes
		offIndex: function (index, fn) {
			if (!this._indexWatchers[index]) return this;
			if (fn) {
				var idx = this._indexWatchers[index].indexOf(fn);
				if (idx >= 0) this._indexWatchers[index].splice(idx, 1);
			} else {
				this._indexWatchers[index] = [];
			}
			return this;
		},

		// Subscribe to changes on an element matched by key field/value
		onKey: function (keyField, keyValue, fn) {
			if (!this._keyWatchers[keyField]) this._keyWatchers[keyField] = {};
			if (!this._keyWatchers[keyField][keyValue]) this._keyWatchers[keyField][keyValue] = [];
			this._keyWatchers[keyField][keyValue].push(fn);
			return this;
		},

		// Unsubscribe from key-level changes
		offKey: function (keyField, keyValue, fn) {
			if (!this._keyWatchers[keyField] || !this._keyWatchers[keyField][keyValue]) return this;
			if (fn) {
				var idx = this._keyWatchers[keyField][keyValue].indexOf(fn);
				if (idx >= 0) this._keyWatchers[keyField][keyValue].splice(idx, 1);
			} else {
				this._keyWatchers[keyField][keyValue] = [];
			}
			return this;
		},

		// Find index of element by key field/value
		findIndexByKey: function (keyField, keyValue) {
			for (var i = 0; i < this.length; i++) {
				if (this[i] && typeof this[i] === 'object' && this[i][keyField] == keyValue) return i;
			}
			return -1;
		},

		// Set value for element matched by key
		setByKey: function (keyField, keyValue, value) {
			var index = this.findIndexByKey(keyField, keyValue);
			if (index >= 0) {
				this.setAt(index, value);
			}
			return this;
		},

		// Internal: notify index watchers
		_notifyIndexWatchers: function (index, value, oldValue) {
			var watchers = this._indexWatchers[index];
			if (watchers) {
				for (var i = 0; i < watchers.length; i++) {
					watchers[i].call(this, value, oldValue, index);
				}
			}
		},

		// Internal: notify key watchers for a given index
		_notifyKeyWatchersForIndex: function (index, value, oldValue) {
			for (var keyField in this._keyWatchers) {
				var kv;
				// determine the key value from the new or old element
				if (value && typeof value === 'object') kv = value[keyField];
				else if (oldValue && typeof oldValue === 'object') kv = oldValue[keyField];

				if (kv != null && this._keyWatchers[keyField][kv]) {
					var watchers = this._keyWatchers[keyField][kv];
					for (var i = 0; i < watchers.length; i++) {
						watchers[i].call(this, value, oldValue, index);
					}
				}
			}
		},

		// Register this array for dependency tracking (used by ReactiveTracker)
		_trackAccess: function () {
			if (window.ReactiveTracker && ReactiveTracker.current) {
				ReactiveTracker.current.addDependency(this, null);
			}
		},

		// Register index access for dependency tracking
		_trackIndexAccess: function (index) {
			if (window.ReactiveTracker && ReactiveTracker.current) {
				ReactiveTracker.current.addDependency(this, index);
			}
		}
	};

	var arrProto = Array.prototype;

	'pop push shift unshift splice reverse sort'
		.split(' ').forEach(function (methodName) {
			var method = arrProto[methodName];
			ObservableArray.prototype[methodName] = function () {
				var returnValue = method.apply(this, arguments);
				var args = [methodName].concat(arrProto.slice.call(arguments));
				this.trigger.apply(this, args);
				return returnValue;
			};
		});

	// add the above native array methods to ObservableArray.prototype
	// These read-only methods also trigger dependency tracking for computed properties
	'slice concat join some every forEach map filter reduce reduceRight indexOf lastIndexOf toString toLocaleString'
		.split(' ').forEach(function (methodName) {
			var method = arrProto[methodName];
			ObservableArray.prototype[methodName] = function () {
				this._trackAccess();
				return method.apply(this, arguments);
			};
		});

	return ObservableArray;
})();